import { FC, useEffect } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import { ComparePageWithIntl } from './hocs/normalizedRouter';
import { NotificationStorageProvider } from './hocs/NotificationStorage';
import { isHostnameContainsCC } from './utils';
import type { ExtendedBaseRouteProps } from './types';

const ComparePageRoute: FC<{ path: string } & ExtendedBaseRouteProps> = ({
    path,
    contextRoot,
    countryCode,
    languageCode,
    bazaarVoiceEnabled,
    pageRoute,
    isPublic,
}) => (
    <Route
        exact
        path={path}
        component={() => (
            <ComparePageWithIntl
                contextRoot={contextRoot}
                countryCode={countryCode}
                languageCode={languageCode}
                bazaarVoiceEnabled={bazaarVoiceEnabled}
                pageRoute={pageRoute}
                isPublic={isPublic}
            />
        )}
    />
);

const RoutesMap: FC<{ pathPrefix: string } & ExtendedBaseRouteProps> = ({ pathPrefix, ...props }) => {
    return (
        <Router basename={props.isPublic ? '' : props.contextRoot}>
            <NotificationStorageProvider>
                <ComparePageRoute
                    path={`${pathPrefix}/:compareSessionId/:skus`}
                    {...props}
                />
                <ComparePageRoute
                    path={`${pathPrefix}/:compareSessionId`}
                    {...props}
                />
                <ComparePageRoute
                    path={pathPrefix}
                    {...props}
                />
            </NotificationStorageProvider>
        </Router>
    )
}

const App: FC<ExtendedBaseRouteProps> = (props) => {
    useEffect(() => {
        window.addEventListener('popstate',() => window.location = window.location);
        return () => {
            window.removeEventListener('popstate',() => window.location = window.location);
        };
    }, []);

    // Every country has CountryCode and LanguageCode set via pathname part of URL:
    // https://se.com/:cc/:lc/
    // https://se.com/us/en/
    //
    // Except for China whose CountryCode is set via hostname:
    // https://schneider-electric.:cc/:lc/
    // https://schneider-electric.cn/:lc/
    if (isHostnameContainsCC()) {
        return <RoutesMap {...props} pathPrefix={`/:lc/${props.pageRoute}`} />;
    }

    return <RoutesMap {...props} pathPrefix={`/:cc/:lc/${props.pageRoute}`} />;
}

export default App;
